import React, { useState } from 'react';
import '../../css/promocion.css'
import promo3 from '../../assets/images/promociones/banner-aniversario-23.webp'
import lateralPromo1 from '../../assets/images/promociones/bfpass.webp'
import lateralPromo2 from '../../assets/images/promociones/adulto-mayor.png'
import { Outlet, Link } from "react-router-dom";
import whatsapp from '../../assets/images/chat.svg'
import formulario from '../../assets/images/formulario-de-contacto.svg'
import mapa from '../../assets/images/mapa.svg'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next';


export default function Promo16() {
   const [copied, setCopied] = useState(false);  
    const promoCode = 'BIKERBF26';  
    const { t } = useTranslation('promo3');

      const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(promoCode);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Oculta el mensaje después de 2 seg
        } catch (err) {
          console.error('Error al copiar el código:', err);
        }
      };

  return (
   <>

    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                  <h3>{t('title')}</h3>
                  <p>Aniversario 23 de Baja Ferries </p>
                </div>                
            </div>
        </div>
    </section>   
    
    <section className='container'>
        <div className='banner-header-promo'>
            <img src={promo3} alt='buen-fin-bajaferries' />
        </div>
    </section>

    <section className='sectionPromo_content'>
        <div className='container'>
            <div className='box_promo'>
                <div className='content_text_promo'>
                    <div className='content_promo'>
                        
                        <p>¡25% de descuento en todos los servicios!  </p>
                        <p>Cabina, cabina VIP, cápsula de descanso, salón VIP, salón ejecutivo, mascotas, bicicletas y automóvil turístico. </p>
                     
                        <div className='content_promo_btn'>                                                
                            <a className='cta_promo' href="tel:8003377437" rel="noopener noreferrer"><span >{t('btn1')} </span></a> 
                            <a target="_blank" className='cta_promo' rel='noopener noreferrer' href='https://wa.me/5218003377437?text=Me%20interesa%20una%20cotización'>{t('btn2')}  </a>
                        </div> 
                        
                    </div>
                                                            
                    <div className='content_promo condiciones-promo'>
                        <h4>{t('text4')}</h4>
                        {/*<p>El tiempo se acaba, ¡Lugares limitados hasta agotar existencias!.</p>*/}
                        <ul>                            
                            <li>• Promoción válida para compras realizadas del 1 al 5 de marzo de 2026.  </li>
                            <li>• Aplica para viajes del 1 de marzo al 12 de julio de 2026. </li>
                            <li>• Consiste en 25% de descuento sobre la tarifa vigente en: Cabina, Cabina VIP, Cápsula de descanso, Salón VIP, Salón Ejecutivo, Mascotas, Bicicletas y Automóvil turístico (hasta 6 metros de longitud). </li>
                            <li>• El beneficio aplica únicamente sobre la tarifa base vigente al momento de la compra. </li>

                            <li>• No acumulable con otras promociones, descuentos o convenios. </li>
                            <li>• Sujeto a disponibilidad y a las políticas vigentes de cambios y cancelaciones de Baja Ferries. </li>
                            <li>* Baja Ferries se reserva el derecho de modificar o cancelar la promoción sin previo aviso.</li>
                                
                        </ul>
                    </div>
                    {/*<div className='content_promo btn-termino-condiciones'>
                    <Link to="/condiciones-de-servicio">Consulta términos y condiciones</Link> 
                    </div>*/}
                </div>
                <div className='content_contador_promo'>

                    <div className='content_promo'>
                        {/*}
                        <div className='content-isotipo'>
                            <img src={bfIso} alt='bf-isotipo'/>
                        </div>
                        <div>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                consequat.
                            </p>

                        </div>
                        <div>
                            <Temporizador targetDate={targetDate} />
                        </div>
                        <div className='lateral-promo'>
                            <Link to="/bf-pass">
                                <img src={lateralPromo1} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                        */}
                        <h4 className='otras-promos'>{t('text6')} </h4>
                        
                        <div className='lateral-promo'>
                            <Link to="/promo-adulto-mayor">
                                <img src={lateralPromo2} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>        
    </section>
    
    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={formulario} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            
                            <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn1')}  </a>  
                           
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/antes-de-viajar">{t('cta_btn2')}  </Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/tarifas">{t('cta_btn3')}</Link>                     
                        </div>
                    </div>
                </div>
            </div>

        </div>
   </section>

        <Outlet />

    <Footer />
   
   </>
  )
}
